import {withTableRow} from './withTableRow';
import {TableRowStyle} from './TableRowStyle';

/**
 * Represents a row in a table.
 * Parent component should be `tbody` or `thead`.
 * Children should be table cells.
 *
 * @component
 */
export const TableRow = withTableRow(TableRowStyle);
